import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getSnapchatSettings = ({
  snapchatUsername
}: Partial<ChatsChannelBase>) => {
  if (!snapchatUsername) return null;

  const url = `https://www.snapchat.com/add/${snapchatUsername}`;

  return {
    provider: ChatsChannelType.snapchat,
    link: { url },
    title: 'Snapchat',
    icon: getChatIcon(ChatsChannelType.snapchat),
    color: 'rgb(255, 252, 0)'
  } as ChatsChannelSetting;
};
